import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class ServiceAreasSelectInputCtrl implements IController {
  serviceAreas: any;
  selectedIds: any;
  multiple: any;
  onSelect: any;

  public isLoading: boolean;
  public searchTerm: string;
  private selectedIdsCopy: any;

  constructor(private systemEventsConfig, private $mdSelect, private $scope: IScope, private $element) {
  }

  $onInit() {
    this.selectedIdsCopy = angular.copy(this.selectedIds);
    this.isLoading = false;


    this.$scope.$on(this.systemEventsConfig.forms.fieldsetToggle, (event, state) => {
      this.isLoading = state;
    });

    this.$element.find('input').on('keydown', function (ev) {
      ev.stopPropagation();
    });

  }

  onClose() {
    this.searchTerm = '';
    if (!_.isEqual(this.selectedIdsCopy, this.selectedIds)) {
      this.selectedIdsCopy = angular.copy(this.selectedIds);
      this.onSelect();
    }
  }


}

angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreasSelectInput', {
    bindings: {
      serviceAreas: '<',
      selectedIds: '<',
      multiple: '<',
      onSelect: '<'
    },
    template: require('./service-areas-select-input.html').default,
    controller: ServiceAreasSelectInputCtrl
  });
